import React from "react";
import { useLang } from "@/lib/useLang";

/**
 * Civic thank-you message shown in frozen state.
 * A warm, partisan-neutral closing note for the citizen audience.
 */
export const CivicThanks = () => {
  const { t } = useLang();
  return (
    <section
      className="brutal-card p-6 md:p-10 fade-up"
      data-testid="civic-thanks-section"
    >
      <h2
        className="font-display uppercase leading-[0.9] tracking-tight mb-4"
        style={{ fontSize: "clamp(2rem, 6vw, 4rem)" }}
        data-testid="civic-thanks-heading"
      >
        {t("civic_thanks_heading")}
      </h2>
      <p
        className="text-lg md:text-xl font-medium leading-relaxed max-w-3xl"
        data-testid="civic-thanks-body"
      >
        {t("civic_thanks_body")}
      </p>
    </section>
  );
};

export default CivicThanks;
